"use strict";
/* eslint-disable max-classes-per-file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorReason = exports.Formatter = exports.ResponseFormatter = exports.ResponseParser = exports.cacheMap = void 0;
exports.cacheMap = {
    default: 'default',
    forceCache: 'force-cache',
    noCache: 'no-cache',
    noStore: 'no-store',
    onlyIfCached: 'only-if-cached',
    reload: 'reload',
};
var ResponseParser = /** @class */ (function () {
    function ResponseParser() {
    }
    return ResponseParser;
}());
exports.ResponseParser = ResponseParser;
var ResponseFormatter = /** @class */ (function () {
    function ResponseFormatter() {
    }
    return ResponseFormatter;
}());
exports.ResponseFormatter = ResponseFormatter;
var Formatter = /** @class */ (function () {
    function Formatter() {
    }
    return Formatter;
}());
exports.Formatter = Formatter;
// eslint-disable-next-line no-shadow
var ErrorReason;
(function (ErrorReason) {
    ErrorReason["Default"] = "DEFAULT";
    ErrorReason["CriticalAction"] = "CriticalAction";
})(ErrorReason = exports.ErrorReason || (exports.ErrorReason = {}));
